import { has } from "lodash";

export function isOfType<T>(objectToCheck: unknown, uniqueKey: keyof T): objectToCheck is T {
    if (objectToCheck === undefined || objectToCheck === null) {
        return false;
    }
    if (has(objectToCheck as T, uniqueKey)) {
        return true;
    }
    return false;
}

export const sleep = (ms: number): Promise<void> => {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
};

export const formatPhoneNumber = (value: string): string => {
    // Remove all non-digit characters
    const digits = value.replace(/\D/g, "");

    // Build the formatted string
    const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (!match) return digits;

    let formatted = "";
    if (match[1]) {
        formatted += `(${match[1]}`;
    }
    if (match[1] && match[1].length === 3 && match[2]) {
        formatted += `)${match[2]}`;
    } else if (match[2]) {
        formatted += match[2];
    }
    if (match[2] && match[2].length === 3 && match[3]) {
        formatted += `-${match[3]}`;
    }

    return formatted;
};

export const getUserId = (): string | undefined => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
        return undefined;
    }
    const payload = accessToken.split(".")[1];
    const decodedPayload = JSON.parse(atob(payload));
    return decodedPayload.id || undefined;
};
